<template>
	<div class="chart-container" ref="chartContainer" :id="'container_chart_'+randId">
		<canvas :id="'chart_'+randId" :width="width" :height="height" v-on:click="click"></canvas>
	</div>
</template>
<script type="text/javascript">
import Chart from 'chart.js'

export default {
	name: "Chart",
	props: [
		"height",
		"type", //chart type 'bar','line',etc
		"labels", //array

		/**
		* MULTI-DATA SET USAGE
		*/
		"datasets", //multiple data sets,
		
		/**
		* SINGLE DATA SET USAGE
		*/
		"data", //array of values, use if chart has single dataset
		"label", //data set label
		"backgroundColor",
		"borderColor",
		'borderWidth', //int
		'options' //options object
	],
	data() {
		return {
			randId: Math.random(),
			width: 300,
			chart: null
		}
	},
	watch: {
		data() {
			this.chart.update()
		},
		datasets() {
			this.chart.update()
		},
		label() {
			this.chart.update()
		},
		labels() {
			this.chart.update()
		},
	},
	methods: {
		click(event) {
			let vm = this
			let activePoints = vm.chart.getElementsAtEvent(event)
			this.$emit("click",activePoints)
		}
	},
	mounted() {
		let vm = this

		this.width = document.getElementById('container_chart_'+this.randId).clientWidth

		vm.$nextTick(() => {

			let ctx = document.getElementById("chart_"+this.randId).getContext("2d")

			let datasets = []

			if (!vm.datasets) {
				datasets = [{
					label: vm.label,
					data: vm.data,
					borderWidth: vm.borderWidth,
					backgroundColor: vm.backgroundColor,
					borderColor: vm.borderColor
				}]
			}
			else 
				datasets = vm.datasets

			vm.chart = new Chart(ctx,{
				type: vm.type,
				data: {
					labels: vm.labels,
					datasets: datasets
				},
				options: vm.options
			})

		})
	}
}
</script>

<style type="text/css" scoped>

</style>